import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export const adminSections = ['licencias', 'swing', 'cotizaciones', 'soporte', 'clientes', 'precios'] as const
export type AdminSection = typeof adminSections[number]
export const adminSectionLabels: Record<AdminSection, string> = { licencias: 'Licencias', swing: 'Swing', cotizaciones: 'Cotizaciones', soporte: 'Soporte', clientes: 'Clientes', precios: 'Precios' }
const parameter = 'seccion'

function isSection(value: string | null): value is AdminSection {
  return value !== null && (adminSections as readonly string[]).includes(value)
}

export function tabId(section: AdminSection) { return `admin-tab-${section}` }
export function panelId(section: AdminSection) { return `admin-panel-${section}` }

/**
 * The administration's section, read from the URL (`?seccion=`) so Back returns to the one before and a link opens
 * one directly; without it, or with one unknown, Licencias. Licencias leaves the URL clean.
 */
export function useAdminSection(): [AdminSection, (section: AdminSection) => void] {
  const [search, setSearch] = useSearchParams()
  const named = search.get(parameter)
  const section: AdminSection = isSection(named) ? named : 'licencias'
  const select = useCallback((next: AdminSection) => {
    setSearch((current) => {
      const updated = new URLSearchParams(current)
      if (next === 'licencias') updated.delete(parameter)
      else updated.set(parameter, next)
      return updated
    })
  }, [setSearch])
  return [section, select]
}
